
export const CHECKOUT_URL = "https://ebookpoint.shop/cart/50600951054588:1";

export const PRODUCT_IMAGE =
  "https://cdn.magicpatterns.com/uploads/pjMDyVcrb1XEGop5w7Sag6/ChatGPT_Image_Jul_23,_2026,_06_52_18_PM.png";

export const COURT_BG =
  "https://cdn.magicpatterns.com/patterns/generated-images/41d30b47-c45c-4f80-b578-a3f1884436af.jpg";

export const BONUS_IMAGES = [
  "https://cdn.magicpatterns.com/uploads/61uwQ6oCVcXEJYyNJN11zq/ChatGPT_Image_Jul_24,_2026,_11_55_52_AM.png",
  "https://cdn.magicpatterns.com/uploads/e6GkDcDqPrZSoQUjNBfxK3/ChatGPT_Image_Jul_24,_2026,_11_55_56_AM.png",
  "https://cdn.magicpatterns.com/uploads/8DrfCqzP3y6aM39wJqtdBd/ChatGPT_Image_Jul_24,_2026,_11_55_59_AM.png",
  "https://cdn.magicpatterns.com/uploads/rCuvRBajDw85bpN5NfwCnd/ChatGPT_Image_Jul_24,_2026,_11_56_01_AM.png",
  "https://cdn.magicpatterns.com/uploads/ryt8L128BJHYD8xYE8EDzz/ChatGPT_Image_Jul_24,_2026,_11_56_03_AM.png",
  "https://cdn.magicpatterns.com/uploads/ehNTCAYEyTxae5ccjYQbzq/ChatGPT_Image_Jul_24,_2026,_12_02_59_PM.png",
  "https://cdn.magicpatterns.com/uploads/g4SixF2UpEfoKBMVfgvxLm/ChatGPT_Image_Jul_24,_2026,_12_03_02_PM.png",
  "https://cdn.magicpatterns.com/uploads/kdjd2mQWtdTThqjokGZo1f/ChatGPT_Image_Jul_24,_2026,_12_03_04_PM.png",
  "https://cdn.magicpatterns.com/uploads/tw7nuLitV5XVMUWKHJ1EXB/ChatGPT_Image_Jul_24,_2026,_12_07_51_PM.png",
  "https://cdn.magicpatterns.com/uploads/4KrMtHpZgEeTEBdp2VnYnZ/ChatGPT_Image_Jul_24,_2026,_12_06_42_PM.png",
];

// Gmail-style reviews
export const GMAIL_REVIEWS = [
  {
    name: "Javier Morales",
    email: "javi.morales@gmail.com",
    initial: "J",
    color: "#e57373",
    subject: "Por fin alguien lo explica bien",
    body:
      "Llevo 6 años jugando y siempre jugué de derecha como me decían. Con este sistema entendí que estaba desaprovechando mi zurda. Cambié de lado y en dos semanas gané más puntos en la red. Increíble.",
    time: "10:24",
  },
  {
    name: "Marta Ruiz",
    email: "marta.ruizg@gmail.com",
    initial: "M",
    color: "#7986cb",
    subject: "Mi bandeja zurda ha mejorado muchísimo",
    body:
      "Nadie en mi club sabía enseñarme la bandeja siendo zurda. Los drills del Tomo 3 son oro puro. Mi profe me pregunta qué he cambiado 😄",
    time: "Ayer",
  },
  {
    name: "Carlos Fernández",
    email: "cfernandez.padel@gmail.com",
    initial: "C",
    color: "#4db6ac",
    subject: "La matriz de pareja me salvó",
    body:
      "Siempre discutíamos con mi compañero por los lados. La infografía del Tomo 2 lo dejó clarísimo. Ahora ganamos torneos de nivel intermedio en Valencia.",
    time: "Lun",
  },
];

export const PROBLEMS = [
  "Te colocas del lado de la derecha porque \"siempre se ha hecho así\", y desperdicias tu revés natural.",
  "Tu compañero diestro y tú chocáis en el centro de la pista porque nadie os explicó cómo repartir los golpes.",
  "Intentas copiar la bandeja de un diestro y te sale forzada, incómoda y sin control.",
  "Los rivales atacan sistemáticamente a tu lado débil y no sabes cómo reorganizarte.",
  "Sientes que tu zurda es una ventaja... pero no tienes ni idea de cómo explotarla en un partido real.",
];

export const MODULES = [
  {
    emoji: "📘",
    title: "Introducción",
    items: [
      "Por qué existe este sistema",
      "Qué vas a lograr",
      "Cómo está organizado el contenido",
      "Cómo usarlo según tu nivel",
    ],
  },
  {
    emoji: "🧠",
    title: "Tomo 1 — El Zurdo en el Pádel: Ventajas Ocultas y Errores que Te Cuestan Partidos",
    items: [
      "1.1 La asimetría que nadie te explicó",
      "1.2 Por qué el 90% de los zurdos juega del lado equivocado",
      "1.3 Las 4 ventajas estructurales del zurdo",
      "1.4 Autodiagnóstico: ¿qué tipo de zurdo eres?",
      "1.5 Errores típicos por posición",
      "1.6 Resumen y checklist",
    ],
  },
  {
    emoji: "🤝",
    title: "Tomo 2 — Posicionamiento de Pareja: Dónde Jugar y Con Quién",
    items: [
      "2.1 La decisión más importante antes de cada partido",
      "2.2 Matriz de compatibilidad de pareja (infografía)",
      "2.3 Cómo elegir el lado según el rival",
      "2.4 Rotaciones y cambios de lado bajo presión",
      "2.5 Comunicación en pista",
      "2.6 Resumen y checklist",
    ],
  },
  {
    emoji: "🎾",
    title: "Tomo 3 — Golpes de Fondo Adaptados: Derecha, Revés y Bandeja Zurda",
    items: [
      "3.1 El fondo de pista como base de todo",
      "3.2 Bandeja zurda",
      "3.3 Víbora invertida",
      "3.4 Globo zurdo",
      "3.5 Drills de fondo (Bloque A)",
      "3.6 Drills de bandeja/víbora (Bloque B)",
      "3.7 Resumen y checklist",
    ],
  },
  {
    emoji: "🔥",
    title: "Tomo 4 — Juego en la Red: La Zona Donde el Zurdo Manda",
    items: [
      "4.1 Por qué la red es tu terreno natural",
      "4.2 Remate cruzado zurdo",
      "4.3 Volea de revés alta",
      "4.4 Cierre de puntos",
      "4.5 Contraataque desde la red",
      "4.6 Drills de red (Bloque C)",
      "4.7 Drills de pareja (Bloque D)",
      "4.8 Resumen y checklist",
    ],
  },
  {
    emoji: "🎯",
    title: "Tomo 5 — Táctica de Partido: Leer al Rival y Explotar tu Lado",
    items: [
      "5.1 La táctica como ventaja decisiva",
      "5.2 Identificar el ataque sistemático al revés",
      "5.3 Patrones de saque y resto para zurdos",
      "5.4 Cambios tácticos según marcador",
      "5.5 Explotar la zona ciega del rival diestro",
      "5.6 Resumen y checklist",
    ],
  },
  {
    emoji: "📅",
    title: "Tomo 6 — Programación de Entrenamiento: 8 Semanas para Automatizar tu Juego",
    items: [
      "6.1 De la teoría a la repetición automática",
      "6.2 Estructura del plan de 8 semanas",
      "6.3 Sesiones específicas de bandeja y víbora zurda",
      "6.4 Test de progreso",
      "6.5 Ajustes según nivel",
      "6.6 Resumen y checklist",
    ],
  },
  {
    emoji: "🩺",
    title: "Tomo 7 — Prevención de Lesiones Específicas del Zurdo",
    items: [
      "7.1 La asimetría también lesiona",
      "7.2 Sobrecargas típicas",
      "7.3 Rutina de activación pre-partido",
      "7.4 Movilidad y fuerza compensatoria",
      "7.5 Señales de alarma",
      "7.6 Resumen y checklist",
    ],
  },
];

export const BONUSES = [
  { emoji: "🧩", title: "Planificador de Pareja Ideal (Excel)", desc: "Encuentra al compañero perfecto según tu perfil zurdo y evita las peleas por los lados." },
  { emoji: "🏋️", title: "16 Drills con Progresión de Dificultad", desc: "Del nivel principiante al avanzado, con progresión medible sesión a sesión." },
  { emoji: "🔎", title: "Sistema de Lectura de Rival en 3 Puntos", desc: "Detecta el punto débil del rival diestro en los primeros games." },
  { emoji: "📆", title: "Programación de 8 Semanas", desc: "Plan cerrado día a día para automatizar tus golpes zurdos." },
  { emoji: "🥎", title: "Guía Rápida de Bandeja Zurda", desc: "El golpe más difícil para el zurdo, explicado paso a paso." },
  { emoji: "✅", title: "Checklist Pre-Partido y Rutina de Activación", desc: "Entra a pista activado y con la cabeza puesta en tu plan." },
  { emoji: "♟️", title: "6 Jugadas Preparadas (lógica táctica)", desc: "Patrones listos para ejecutar cuando el marcador aprieta." },
  { emoji: "🤸", title: "Rutina de Calentamiento Específica", desc: "Diseñada para la asimetría del cuerpo zurdo." },
  { emoji: "✋", title: "Guía de Empuñaduras Zurdas", desc: "Cada golpe con su empuñadura correcta para tu mano dominante." },
  { emoji: "🗺️", title: "Atlas Visual de Cancha", desc: "Zonas, coberturas y rotaciones en diagramas claros." },
];

export const STAR_REVIEWS = [
  {
    name: "Álvaro Giménez",
    city: "Madrid",
    text: "Material serio, nada de humo. Lo aplicable desde el primer día. Los diagramas del Atlas de Cancha valen el precio solo.",
  },
  {
    name: "Nuria Sánchez",
    city: "Sevilla",
    text: "Soy zurda y por fin dejé de sentirme rara en pista. La guía de bandeja zurda me cambió el juego por completo.",
  },
  {
    name: "Pablo Herrera",
    city: "Barcelona",
    text: "El plan de 8 semanas es realista y se puede seguir aunque trabajes. En dos meses subí de nivel en mi liga.",
  },
  {
    name: "Lucía Romero",
    city: "Zaragoza",
    text: "Lo mejor es el sistema de lectura de rival. Ahora sé exactamente dónde atacar. Recomendadísimo.",
  },
];

export const CAROUSEL_TESTIMONIALS = [
  { name: "Sergio Navarro", age: 34, city: "Málaga", text: "Zurdo desde siempre, jugando mal desde siempre 😂 Este ebook me reordenó la cabeza. Ahora domino la red." },
  { name: "David Ortega", age: 41, city: "Valencia", text: "Lo compré con dudas y me sorprendió. Muy práctico, directo al grano. Mi compañero también lo quiere ya." },
  { name: "Raúl Castro", age: 29, city: "Bilbao", text: "La víbora invertida es mi nueva arma. Los rivales no saben por dónde les viene. Brutal el Tomo 4." },
  { name: "Marta Vidal", age: 37, city: "Alicante", text: "Por fin un recurso pensado para zurdas. Muy bien explicado y con drills que de verdad funcionan." },
  { name: "Iván Delgado", age: 45, city: "Granada", text: "A mi edad pensaba que ya no mejoraría. El plan de 8 semanas me demostró lo contrario. Gracias." },
];

export const OBJECTIONS = [
  { q: "¿Sirve si soy principiante?", a: "Sí. El sistema incluye una ruta según tu nivel y un autodiagnóstico inicial. Empiezas por lo básico y avanzas con seguridad." },
  { q: "¿Y si mi pareja es diestra?", a: "Precisamente por eso existe el Tomo 2 y el Planificador de Pareja: para que os coloquéis y comuniquéis sin chocar." },
  { q: "¿Es solo teoría o hay práctica?", a: "Hay +15 drills con progresión, un plan de 8 semanas y checklists. Es 80% aplicación en pista." },
  { q: "¿Cómo lo recibo?", a: "Es 100% digital en PDF (y algunos Excel). Entrega inmediata tras el pago a tu correo." },
  { q: "¿Y si no me convence?", a: "El contenido está pensado para darte resultados desde la primera semana. Es un pago único, sin suscripciones." },
];

export const SPANISH_NAMES = [
  "Alejandro G.", "María L.", "Javier M.", "Carmen R.", "Sergio P.",
  "Laura S.", "Daniel F.", "Cristina V.", "Adrián T.", "Elena C.",
  "Rubén D.", "Paula M.", "Óscar N.", "Sara H.", "Marc B.",
];

export const SPANISH_CITIES = [
  "Madrid", "Barcelona", "Valencia", "Sevilla", "Zaragoza", "Málaga",
  "Bilbao", "Alicante", "Granada", "Murcia", "Palma", "Vigo",
  "Gijón", "Vitoria", "A Coruña", "San Sebastián",
];
